'use strict';
import angular from 'angular';

angular.module('notifications.services', [])
    .service('NotificationsService', NotificationsService)
    .service('NotificationsFactory', NotificationsFactory);

NotificationsService.$inject = ['NotificationsFactory', '$q'];
function NotificationsService (NotificationsFactory, $q) {
    var NOTIFICATION_TYPE_SITE = 1;
    var service = {};
    service.notifications = null;
    service.notification = null;
    service.notificationId = null;

    service.NOTIFICATION_OBJECT_TYPE_ORDER = 1;
    service.NOTIFICATION_OBJECT_TYPE_LINE_ITEM = 2;
    service.NOTIFICATION_OBJECT_TYPE_TASK = 3;
    service.NOTIFICATION_OBJECT_TYPE_COMMENT = 4;
    service.STATUS_NOTIFICATION_ARCHIVED = 24;

    // Get up-to 50 Notifications
    service.getSomeSiteNotifications = function() {
        var deferred = $q.defer();
        var params = {'typeId' : NOTIFICATION_TYPE_SITE, 'limit' : 50 };

        NotificationsFactory.getCurrentNotifications().get(params).$promise.then(function(data) {
            service.notifications = data.notifications;
            deferred.resolve();
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    // Get all current Notifications
    service.getCurrentSiteNotifications = function() {
        var deferred = $q.defer();
        var params = {'typeId' : NOTIFICATION_TYPE_SITE};

        NotificationsFactory.getCurrentNotifications().get(params).$promise.then(function(data) {
            service.notifications = data.notifications;
            deferred.resolve();
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.getArchivedSiteNotifications = function() {
        var deferred = $q.defer();
        var params = {
            'typeId' : NOTIFICATION_TYPE_SITE,
            'showArchived' : '1'
        };

        NotificationsFactory.getArchivedNotifications().get(params).$promise.then(function(data) {
            service.notifications = data.notifications;
            deferred.resolve();
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    // Get get total number notifications according to archived
    service.getNumberOfNotifications = function(showArchived) {
        const deferred = $q.defer();
        const params = {
            'typeId' : NOTIFICATION_TYPE_SITE,
            'showArchived' : showArchived,
        };

        NotificationsFactory.getNumberOfNotifications().get(params).$promise.then(function(data) {
            if (isNaN(data.total)) {
                deferred.reject(data.errors);
            } else {
                deferred.resolve(data);
            }
        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    // Get Notifications with pagination
    service.getNotificationsWithPagination = function(params) {
        const deferred = $q.defer();
        params.typeId = NOTIFICATION_TYPE_SITE;

        NotificationsFactory.getNotificationsWithPagination().get(params).$promise.then(function(data) {
            if (data.notifications) {
                deferred.resolve(data);
            } else {
                deferred.reject(data.errors);
            }

        }, function(error) {
            deferred.reject(error);
        });

        return deferred.promise;
    };

    service.archive = function(notificationId) {
        var deferred = $q.defer();
        var params = {'id' : notificationId};

        NotificationsFactory.archive().update(params).$promise.then(function(data) {
            service.notification = data.notification;
            deferred.resolve();
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteNotification = function(notificationId) {
        var deferred = $q.defer();
        var params = {'id' : notificationId};

        NotificationsFactory.notification().delete(params).$promise.then(function(data) {
            service.notificationId = data.id;
            deferred.resolve();
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.deleteMultipleNotifications = function(notificationIds) {
        var deferred = $q.defer();
        var params = {};
        params.notificationIds = notificationIds;

        NotificationsFactory.deleteNotifications().delete(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    service.archiveMultipleNotifications = function(notificationIds) {
        var deferred = $q.defer();
        var params = {};
        params.notificationIds = notificationIds;

        NotificationsFactory.archiveNotifications().update(params).$promise.then(function(data) {
            deferred.resolve(data);
        }, function(error) {
            deferred.reject();
        });

        return deferred.promise;
    };

    return service;
}

NotificationsFactory.$inject = ['$resource', 'AppConfig'];
function NotificationsFactory($resource, AppConfig) {
    var factory = {};

    factory.getCurrentNotifications = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications', null, {
            'get': {
                method: 'GET',
                isArray: false
            }
        });
    };

    factory.getArchivedNotifications = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications', null, {
            'get' :{
                method : 'GET',
                isArray : false
            }
        });
    };

    factory.getNumberOfNotifications = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications/getNumberOfNotifications', null, {
            'get' :{
                method : 'GET',
                isArray : false
            }
        });
    };

    factory.getNotificationsWithPagination = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications/getNotificationsWithPagination', null, {
            'get' :{
                method : 'GET',
                isArray : false
            }
        });
    };

    factory.archive = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications/archive', null, {
            'update' :{
                method:'PUT'
            }
        });
    };

    factory.notification = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications/notification', null, {
            'update' :{
                method:'PUT'
            },
            'delete' :{
                method:'DELETE'
            }
        });
    };

    factory.deleteNotifications = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications/deleteNotifications', null, {
            'delete' :{
                method:'PUT'
            }
        });
    };

    factory.archiveNotifications = function() {
        return $resource(AppConfig.IO_API_URL + 'notifications/archiveNotifications', null, {
            'update' :{
                method:'PUT'
            }
        });
    };

    return factory;

}